import { Link, useLocation } from "react-router-dom";
import { FloatingMenu } from "./FloatingMenu";
import { Footer } from "./Footer";

export const Layout = ({ children, hideFooter = false }) => {
  const { pathname } = useLocation();
  return (
    <>
      {pathname !== "/" && <Link to="/" className="signature-home" aria-label="Councilman Wood, Home" data-testid="signature-home">
        <picture>
          <source srcSet="/assets/wordmark-logo.webp" type="image/webp" />
          <img src="/assets/wordmark-logo.png" width="720" height="720" alt="Councilman Wood" draggable={false} />
        </picture>
      </Link>}
      <FloatingMenu />
      <main className="page-enter">{children}</main>
      {!hideFooter && <Footer />}
    </>
  );
};
